import { wccModules } from 'enums/wccModules';
import { inject, injectable } from 'inversify';
import { Subscribable, SubscribableOrNullableValue } from 'knockout';
import CommunityNavigationWidgetGroupModel from '../group';
import CommunityNavigationWidgetItemModel from '../item';
import { CommunityNavigationWidgetLinkModel } from '../link';
import './group.html';

interface CommunityMobileNavigationWidgetGroupVMConfig {
    data?: SubscribableOrNullableValue<CommunityNavigationWidgetGroupModel>
    onClick?: Action
}

@injectable()
export default class CommunityMobileNavigationWidgetGroupVM {
    isExpanded = ko.observable(false)

    items: Subscribable<Array<CommunityNavigationWidgetItemModel>>
    isCollapsed: Subscribable<boolean>

    header: Subscribable<CommunityNavigationWidgetLinkModel>
    onClick: Action

    constructor(
        @inject(wccModules.componentConfig) config: CommunityMobileNavigationWidgetGroupVMConfig,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo
    ) {
        this.onClick = config.onClick ?? _.noop;

        const data = ko.flattenComputed(config.data);
        const title = data.pluck(d => d.title);
        this.items = data.pluck(d => d.items, []);
        const toDoCount = data.pluck(d => d.toDoCount);
        const isRoot = data.pluck(d => d.isRoot);

        this.header = ko.pureComputed(() => {
            return new CommunityNavigationWidgetLinkModel({
                title: title(),
                toDoCount: toDoCount(),
                isRoot: isRoot()
            });
        });

        this.isCollapsed = this.isExpanded.not();

        ko.applyBindingsToNode(info.element, {
            'css': {
                'community__mobile-navigation__group': true
            }
        });
    }

    toggle = () => {
        this.isExpanded.toggle();
    }
}